module.exports = __webpack_public_path__ + "static/media/shirove.9adc031a.jpg";